import React from 'react'
import { Card, Tag, Icon, Empty } from 'antd'
import * as _ from 'lodash'
import { ComponentExt } from 'util/reactExt'
import { RouteComponentProps } from 'react-router'
import Bread from './components/breadCrumb'

import styles from './index.scss'

interface IProps extends RouteComponentProps<any> {}
interface IState {}
// 征文 详情
export default class ActivityDetail extends ComponentExt<IProps, IState> {
  state = {
    activityList: [],
    recommendList: [],
    tags: [],
    intro: '',
    detail: {},
    selectedTags: '',
    banner: '',
  }

  async componentDidMount() {
    this.handleFetchData(0)
  }

  handleFetchData = data => {
    const {
      location: { search },
    }: any = this.props
    let id = Number(new URLSearchParams(search).get('activityId'))

    if (!!data) {
      id = data
    }
    this.setState(
      {
        detail: {},
      },
      () => {
        this.handleFetchActivityList()
        this.handleFetchActivityIntro()
        this.handleFetchLabelList({ label_type: 2 })
        this.handleFetchActivityBanner()
        this.handleFetchHotArticleList({ label_type: 2 })
        this.handleFetchActivityDetail({ id })
      },
    )
  }

  async handleFetchActivityIntro() {
    try {
      const intro = await this.api.family.getFamilyActivityIntroDuce()
      // console.log('intro', intro)
      this.setState({ intro })
    } catch (err) {
      console.error(err.message)
    }
  }

  async handleFetchActivityBanner() {
    try {
      const banner = await this.api.family.getFamilyActivityBanner()
      // console.log('banner', banner)
      this.setState({
        banner: banner[0],
      })
    } catch (err) {
      console.error(err.message)
    }
  }

  async handleFetchLabelList(params: { label_type: number }) {
    try {
      const tags = await this.api.family.getFamilyLabelList(params)
      this.setState({ tags }, () => this.forceUpdate())
    } catch (err) {
      console.error(err.message)
    }
  }

  async handleFetchActivityList() {
    try {
      const {
        data: activityList,
      } = await this.api.family.getFamilyActivityList({})
      this.setState({ activityList })
    } catch (err) {
      console.error(err.message)
    }
  }

  async handleFetchActivityDetail(param: { id: number }) {
    try {
      const detail = await this.api.family.getFamilyActivityDetail(param)
      this.setState({
        detail,
      })
    } catch (err) {
      console.error(err.message)
    }
  }

  async handleFetchHotArticleList(params) {
    try {
      const recommendList = await this.api.family.getFamilyHotArticleList(
        params,
      )
      this.setState({
        recommendList,
      })
    } catch (err) {
      console.error(err.message)
    }
  }

  handleSliceString = (str, limit = 30) => {
    let res = str
    if (str && str.length > limit) {
      res = `${str.slice(0, limit)}···`
      return res
    }
    return res
  }

  handleRenderTag = () => {
    const { tags, selectedTags } = this.state
    if (_.isEmpty(tags)) {
      return
    }
    return _.map(tags, itm => (
      <Tag key={itm.id} onClick={e => this.handleClickList(e, itm, 'tag')}>
        {itm.label_name}
      </Tag>
    ))
  }

  handleRenderActivity = () => {
    const {
      activityList,
      banner,
      intro,
    }: { activityList: any; banner: any; intro: string } = this.state
    if (_.isEmpty(activityList)) {
      return
    }
    return (
      <ul>
        <div
          className={styles.banner}
          onClick={e => this.handleClickList(e, intro, 'actBanner')}
        >
          <img
            height="145"
            width="224"
            src={banner.img_url}
            alt={banner.remark}
          />
        </div>
        {_.map(activityList, (itm, idx) => (
          <li key={idx} onClick={e => this.handleClickList(e, itm.id, 'act')}>
            {this.handleSliceString(itm.title)}
          </li>
        ))}
      </ul>
    )
  }

  handleRenderRecommend = () => {
    const { recommendList } = this.state
    if (_.isEmpty(recommendList)) {
      return
    }
    return _.map(recommendList, (itm, idx) => {
      if (idx === 0) {
        return (
          <div
            className={styles.banner}
            key={itm.id}
            onClick={e => this.handleClickList(e, itm, 'li')}
          >
            <img src={itm.img_url} alt={itm.article_desc} />
            <p>
              {this.handleSliceString(itm.title)}
              {itm.type === '1000101' && <Icon type="play-square" />}
            </p>
          </div>
        )
      }
      return (
        <li key={itm.id} onClick={e => this.handleClickList(e, itm, 'li')}>
          <p>
            {this.handleSliceString(itm.title)}
            {itm.type === '1000101' && <Icon type="play-square" />}
          </p>
        </li>
      )
    })
  }

  handleRenderActivityContent = details => (
    <div key={details.id}>
      <Card>
        <div className={styles.title}>
          <h4>{details.title}</h4>
          <p>
            <span>{details.notice_time}</span>
          </p>
        </div>
        <div
          dangerouslySetInnerHTML={{ __html: details.content }}
          className={styles.content}
        />
      </Card>
    </div>
  )

  handleClickList = (e, data, type) => {
    // 阻止冒泡
    e.stopPropagation()
    const WINOPEN = url => {
      window.open(window.location.origin + url, '_blank')
    }
    // console.log('data', data)
    if (type === 'act') {
      WINOPEN(`#/team/actdetail/act?activityId=${data}`)
    } else if (type === 'actBanner') {
      WINOPEN(`#/team/actintro/act?actBanner=${data}`)
    } else if (type === 'tag') {
      WINOPEN(
        `#/team/list/${type}?tagName=${data.label_name}&labelId=${data.id}`,
      )
    }
  }

  handleClickBreadCrumb = (link): any => {
    if (link) {
      const { history }: any = this.props
      history.push('/team')
    }
  }

  render() {
    const { detail } = this.state
    const breadCrumb: any = [
      { linkTo: '/team', text: '经传人' },
      { linkTo: '', text: '专题详情' },
    ]
    const mapProps: any = {
      breadCrumb: breadCrumb,
      handleClickBreadCrumb: this.handleClickBreadCrumb,
    }
    return (
      <div className={styles.detail}>
        <Bread {...mapProps} />
        <div className={styles.container}>
          {!_.isEmpty(detail) ? (
            this.handleRenderActivityContent(detail)
          ) : (
            <Card>
              <Empty />
            </Card>
          )}
        </div>
        <div className={styles.others}>
          <div className={styles.contentRtBox}>
            <Card className={styles.activity} title="征文活动">
              {this.handleRenderActivity()}
            </Card>
            <Card title="全部标签">{this.handleRenderTag()}</Card>
            <Card className={styles.recommend} title="推荐">
              <ul>{this.handleRenderRecommend()}</ul>
            </Card>
          </div>
        </div>
      </div>
    )
  }
}
